module.exports = __webpack_public_path__ + "static/19-982a4a4152bb05349531df7bfe64c2a9.jpg";